const aaaaValidator = (value) => {
  if (!value) return "validate.aaaa_empty";
  const regex = /^[0-9a-fA-F:]+$/;
  return regex.test(value) ? true : "validate.aaaa_failed";
};

export { aaaaValidator };
